import { CompaniesVersionsService_companyVersionServiceGetEntity } from '@festina/legalentity-general-types/legalentity/hooks/CompaniesVersionsService_companyVersionServiceGetEntity'

export const useLazyFetchCompanyVersion =
  CompaniesVersionsService_companyVersionServiceGetEntity.useLazyQuery
